import React, { useState } from "react";
import {
  VYLABS_BASE_URL,
  VIEW_VENDOR_FILE_URL,
  UPDATE_VENDORS_INFO_FIELDS,
  GET_VENDOR_FILE_UPLOAD_URL,
} from "../../../helper/url_helper";
import { post } from "../../../helper/Api_helper";
import Button from "../../../Common/Button/Button";
import ResumeViewerModal from "../Candidates/CandidateDetails/ResumeViewerModal";
function VendorDocuments(props) {
  const {
    isEditingVendor,
    selectedVendor,
    editAchFile,
    editVoidChequeFile,
    editAuditDocument,
    handleEditAchFileChange,
    handleEditVoidChequeFileChange,
    handleEditAuditDocumentChange,
    onVendorUpdate,
  } = props || {};

  const { files = [], id: vendorId } = selectedVendor || {};
  const [updatingFileType, setUpdatingFileType] = useState(null);
  const [documentUrl, setDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const getFileByType = (fileType) => {
    return files.find((file) => file.file_type === fileType) || {};
  };

  const achFile = getFileByType("ach_upload");
  const voidChequeFile = getFileByType("void_cheque_upload");
  const auditDocument = getFileByType("audit_document");

  const getFileViewUrl = async (fileId, fileName) => {
    try {
      const response = await post(VYLABS_BASE_URL, VIEW_VENDOR_FILE_URL, {
        file_id: fileId,
      });
      setShowDocumentModal(true);
      setDocumentUrl(response.url);
      setDocumentName(fileName);
    } catch (error) {
      console.error("Error fetching file URL:", error);
    }
  };

  const uploadFileToS3 = async (file, fileType) => {
    if (!file) return null;

    try {
      const response = await post(VYLABS_BASE_URL, GET_VENDOR_FILE_UPLOAD_URL, {
        file_name: file.name,
      });
      const { url, object_key } = response;

      if (!url || !object_key) {
        throw new Error("Invalid response from get-upload-url API");
      }

      const uploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!uploadResponse.ok) {
        throw new Error(
          `Failed to upload ${fileType} to S3: ${uploadResponse.status}`
        );
      }

      return {
        file_name: file.name,
        object_key: object_key,
      };
    } catch (error) {
      console.error(`Error uploading ${fileType} to S3:`, error);
      throw error;
    }
  };

  const updateVendorDocument = async (fileType, file) => {
    if (!vendorId || !file) {
      console.error("Vendor ID or file is missing");
      return;
    }

    setUpdatingFileType(fileType);

    try {
      const uploadedFileData = await uploadFileToS3(file, fileType);

      if (!uploadedFileData) {
        throw new Error("File upload failed");
      }
      let payload = {
        id: vendorId,
      };

      if (fileType === "ach_upload") {
        payload.ach_file_upload = uploadedFileData;
      } else if (fileType === "void_cheque_upload") {
        payload.void_cheque_file_upload = uploadedFileData;
      } else if (fileType === "audit_document") {
        payload.audit_document_file_upload = uploadedFileData;
      }
      await post(VYLABS_BASE_URL, UPDATE_VENDORS_INFO_FIELDS, payload);
      if (fileType === "ach_upload") {
        handleEditAchFileChange({ target: { files: [] } });
      } else if (fileType === "void_cheque_upload") {
        handleEditVoidChequeFileChange({ target: { files: [] } });
      } else if (fileType === "audit_document") {
        handleEditAuditDocumentChange({ target: { files: [] } });
      }
      if (onVendorUpdate) {
        onVendorUpdate();
      }
    } catch (error) {
      console.error(`Error updating ${fileType}:`, error);
    } finally {
      setUpdatingFileType(null);
    }
  };

  return (
    <div>
      <div className="client-details-container">
        <div className="client-details-inner-container">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 0,
              gap: "48px",
            }}
          >
            <div className="info-header">
              <span
                className="detail-label"
                style={{
                  color: "#6a69eb",
                  fontSize: "20px",
                  fontWeight: "500",
                  marginLeft: "10px",
                }}
              >
                File Uploads
              </span>
            </div>
          </div>
          <div className="candidate-information">
            <div className="detail-content">
              {isEditingVendor ? (
                <>
                  <div className="vendor-client-file-input">
                    <div style={{ width: "100%" }}>
                      <label>ACH Upload</label>
                      <input
                        type="file"
                        name="achFile"
                        accept=".pdf,.doc,.docx"
                        onChange={handleEditAchFileChange}
                        style={{ display: "block", marginTop: "5px" }}
                      />
                      {editAchFile && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#6a69eb",
                            fontSize: "14px",
                          }}
                        >
                          Selected: {editAchFile.name}
                        </div>
                      )}
                      {achFile?.file_name && !editAchFile && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#888",
                            fontSize: "14px",
                          }}
                        >
                          Current file: {achFile.file_name}
                        </div>
                      )}
                      {editAchFile && (
                        <Button
                          label={
                            updatingFileType === "ach_upload"
                              ? "Updating..."
                              : "Update ACH File"
                          }
                          event={() =>
                            updateVendorDocument("ach_upload", editAchFile)
                          }
                          disabled={updatingFileType === "ach_upload"}
                          style={{ marginTop: "10px" }}
                        />
                      )}
                    </div>
                    <div style={{ width: "100%" }}>
                      <label>VOID Cheque Upload</label>
                      <input
                        type="file"
                        name="voidChequeFile"
                        accept=".pdf,.doc,.docx"
                        onChange={handleEditVoidChequeFileChange}
                        style={{ display: "block", marginTop: "5px" }}
                      />
                      {editVoidChequeFile && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#6a69eb",
                            fontSize: "14px",
                          }}
                        >
                          Selected: {editVoidChequeFile.name}
                        </div>
                      )}
                      {voidChequeFile?.file_name && !editVoidChequeFile && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#888",
                            fontSize: "14px",
                          }}
                        >
                          Current file: {voidChequeFile.file_name}
                        </div>
                      )}
                      {editVoidChequeFile && (
                        <Button
                          label={
                            updatingFileType === "void_cheque_upload"
                              ? "Updating..."
                              : "Update Void Cheque"
                          }
                          event={() =>
                            updateVendorDocument(
                              "void_cheque_upload",
                              editVoidChequeFile
                            )
                          }
                          disabled={updatingFileType === "void_cheque_upload"}
                          style={{ marginTop: "10px" }}
                        />
                      )}
                    </div>
                    <div style={{ width: "100%" }}>
                      <label>Audit Document</label>
                      <input
                        type="file"
                        name="documentType"
                        accept=".pdf,.doc,.docx"
                        onChange={handleEditAuditDocumentChange}
                        style={{ display: "block", marginTop: "5px" }}
                      />
                      {editAuditDocument && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#6a69eb",
                            fontSize: "14px",
                          }}
                        >
                          Selected: {editAuditDocument.name}
                        </div>
                      )}
                      {auditDocument?.file_name && !editAuditDocument && (
                        <div
                          style={{
                            marginTop: "5px",
                            color: "#888",
                            fontSize: "14px",
                          }}
                        >
                          Current file: {auditDocument.file_name}
                        </div>
                      )}
                      {editAuditDocument && (
                        <Button
                          label={
                            updatingFileType === "audit_document"
                              ? "Updating..."
                              : "Update Audit Document"
                          }
                          event={() =>
                            updateVendorDocument(
                              "audit_document",
                              editAuditDocument
                            )
                          }
                          disabled={updatingFileType === "audit_document"}
                          style={{ marginTop: "10px" }}
                        />
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="vendor-documents-outer-container">
                    <div className="vendor-documents-containers">
                      <div className="document-label-container">
                        <label>ACH File : </label>
                        <h5 className="document-file-name">
                          {achFile?.file_name || "N/A"}
                        </h5>
                      </div>
                      {achFile?.id && (
                        <Button
                          label="View File"
                          event={() =>
                            getFileViewUrl(achFile.id, achFile.file_name)
                          }
                        />
                      )}
                    </div>
                    <div className="vendor-documents-containers">
                      <div className="document-label-container">
                        <label>Void Cheque File : </label>
                        <h5 className="document-file-name">
                          {voidChequeFile?.file_name || "N/A"}
                        </h5>
                      </div>
                      {voidChequeFile?.id && (
                        <Button
                          label="View File"
                          event={() =>
                            getFileViewUrl(
                              voidChequeFile.id,
                              voidChequeFile.file_name
                            )
                          }
                        />
                      )}
                    </div>
                    <div className="vendor-documents-containers">
                      <div className="document-label-container">
                        <label>Document Type : </label>
                        <h5 className="document-file-name">
                          {auditDocument?.file_name || "N/A"}
                        </h5>
                      </div>
                      {auditDocument?.id && (
                        <Button
                          label="View File"
                          event={() =>
                            getFileViewUrl(
                              auditDocument.id,
                              auditDocument.file_name
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showDocumentModal && (
        <ResumeViewerModal
          url={documentUrl}
          name={documentName}
          onClose={() => setShowDocumentModal(false)}
          isOpen={showDocumentModal}
        />
      )}
    </div>
  );
}

export default VendorDocuments;
